import React from 'react';
import { Heart, Activity, Users } from 'lucide-react';
import { SecondaryModuleProps } from '../../types/secondaryModule';
import { SecondaryModuleContainer } from './SecondaryModuleContainer';
export function GrowthModule({
  moduleId,
  isOpen,
  onClose
}: SecondaryModuleProps) {
  const data = {
    overallHealthStatus: {
      healthIndex: 89,
      riskLevelDistribution: {
        level1: 3,
        level2: 20,
        level3: 5,
        good: 72
      },
      symptomTypeDistribution: [{
        symptom: '抑郁',
        percentage: 12
      }, {
        symptom: '焦虑',
        percentage: 25
      }, {
        symptom: '失眠',
        percentage: 18
      }, {
        symptom: '人际敏感',
        percentage: 15
      }]
    },
    interventionEffectiveness: {
      assessmentCompletionRate: 96,
      interventionCoverageRate: 89,
      improvementRate: 78
    },
    aiInsights: [{
      type: 'finding' as const,
      content: '本月心理健康指数为89分，较上月提升2.5分'
    }, {
      type: 'finding' as const,
      content: '一级关注学生数量下降至3人，干预效果显著'
    }, {
      type: 'suggestion' as const,
      content: '建议针对高三年级开展考前减压团体辅导'
    }, {
      type: 'suggestion' as const,
      content: '建议增加心理咨询室开放时段，满足学生需求'
    }, {
      type: 'prediction' as const,
      content: '预计期末考试前焦虑情绪可能有所上升，需提前干预'
    }]
  };
  return <SecondaryModuleContainer moduleId={moduleId} isOpen={isOpen} onClose={onClose} data-id="element-219">
      <div className="grid grid-cols-3 gap-6" data-id="element-220">
        <div className="col-span-2 space-y-6" data-id="element-221">
          {/* Health Index */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-222">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-223">
              <div className="w-1 h-5 bg-[#F472B6] rounded-full" data-id="element-224"></div>
              整体健康态势
            </h3>
            <div className="grid grid-cols-4 gap-4" data-id="element-225">
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-226">
                <div className="text-3xl font-bold text-[#F472B6] mb-1" data-id="element-227">
                  {data.overallHealthStatus.healthIndex}
                </div>
                <div className="text-sm text-gray-400" data-id="element-228">心理健康指数</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-229">
                <div className="text-3xl font-bold text-red-400 mb-1" data-id="element-230">
                  {data.overallHealthStatus.riskLevelDistribution.level1}
                </div>
                <div className="text-sm text-gray-400" data-id="element-231">一级关注</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-232">
                <div className="text-3xl font-bold text-orange-400 mb-1" data-id="element-233">
                  {data.overallHealthStatus.riskLevelDistribution.level2}
                </div>
                <div className="text-sm text-gray-400" data-id="element-234">二级关注</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-235">
                <div className="text-3xl font-bold text-green-400 mb-1" data-id="element-236">
                  {data.overallHealthStatus.riskLevelDistribution.good}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-237">良好比例</div>
              </div>
            </div>
          </div>

          {/* Symptom Distribution */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-238">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-239">
              <Activity className="w-5 h-5 text-[#F472B6]" data-id="element-240" />
              症状类型分布
            </h3>
            <div className="space-y-4" data-id="element-241">
              {data.overallHealthStatus.symptomTypeDistribution.map((symptom, index) => <div key={index} data-id="element-242">
                    <div className="flex items-center justify-between mb-2" data-id="element-243">
                      <span className="text-white text-sm" data-id="element-244">
                        {symptom.symptom}
                      </span>
                      <span className="text-[#F472B6] font-bold" data-id="element-245">
                        {symptom.percentage}%
                      </span>
                    </div>
                    <div className="h-3 bg-white/5 rounded-full overflow-hidden" data-id="element-246">
                      <div className="h-full bg-gradient-to-r from-[#F472B6] to-[#EC4899] rounded-full" style={{
                  width: `${symptom.percentage}%`
                }} data-id="element-247"></div>
                    </div>
                  </div>)}
            </div>
          </div>

          {/* Intervention Effectiveness */}
          <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-248">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-249">
              <Users className="w-5 h-5 text-[#F472B6]" data-id="element-250" />
              干预效果评估
            </h3>
            <div className="grid grid-cols-3 gap-4" data-id="element-251">
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-252">
                <div className="text-3xl font-bold text-[#F472B6] mb-1" data-id="element-253">
                  {data.interventionEffectiveness.assessmentCompletionRate}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-254">测评完成率</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-255">
                <div className="text-3xl font-bold text-green-400 mb-1" data-id="element-256">
                  {data.interventionEffectiveness.interventionCoverageRate}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-257">干预覆盖率</div>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-lg" data-id="element-258">
                <div className="text-3xl font-bold text-blue-400 mb-1" data-id="element-259">
                  {data.interventionEffectiveness.improvementRate}%
                </div>
                <div className="text-sm text-gray-400" data-id="element-260">改善率</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: AI Insights */}
        <div className="space-y-6" data-id="element-261">
          <div className="glass-panel p-6 rounded-xl border border-[#F472B6]/30 bg-gradient-to-br from-[#F472B6]/10 to-transparent" data-id="element-262">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-263">
              <div className="w-8 h-8 rounded-full bg-[#F472B6]/20 flex items-center justify-center" data-id="element-264">
                <Heart className="w-5 h-5 text-[#F472B6]" data-id="element-265" />
              </div>
              易教智能体洞察
            </h3>
            <p className="text-sm text-gray-400 mb-6" data-id="element-266">
              基于身心健康数据，易教智能体为您生成以下洞察：
            </p>

            <div className="space-y-4" data-id="element-267">
              <div data-id="element-268">
                <div className="text-sm font-bold text-[#F472B6] mb-2" data-id="element-269">
                  💡 关键发现
                </div>
                <div className="space-y-2" data-id="element-270">
                  {data.aiInsights.filter(insight => insight.type === 'finding').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-[#F472B6]/30 py-1" data-id="element-271">
                        {insight.content}
                      </div>)}
                </div>
              </div>

              <div data-id="element-272">
                <div className="text-sm font-bold text-green-400 mb-2" data-id="element-273">
                  🎯 建议措施
                </div>
                <div className="space-y-2" data-id="element-274">
                  {data.aiInsights.filter(insight => insight.type === 'suggestion').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-green-400/30 py-1" data-id="element-275">
                        {insight.content}
                      </div>)}
                </div>
              </div>

              <div data-id="element-276">
                <div className="text-sm font-bold text-orange-400 mb-2" data-id="element-277">
                  📊 预测趋势
                </div>
                <div className="space-y-2" data-id="element-278">
                  {data.aiInsights.filter(insight => insight.type === 'prediction').map((insight, index) => <div key={index} className="text-sm text-gray-300 pl-4 border-l-2 border-orange-400/30 py-1" data-id="element-279">
                        {insight.content}
                      </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SecondaryModuleContainer>;
}